import type { AxiosInstance } from 'axios'
import { wrapApiCall } from '@/lib/axios'
import type {
  LeadFormSettings,
  UpdateLeadFormSettingsPayload,
  UploadBackgroundResponse,
  UploadLogoResponse,
} from './model'

export const LeadFormService = (client: AxiosInstance) => {
  return {
    async getSettings(branchId: number): Promise<LeadFormSettings> {
      const { data } = await wrapApiCall(() =>
        client.get<LeadFormSettings>(`/crm/branches/${branchId}/lead-form/settings`)
      )
      return data
    },

    async updateSettings(
      branchId: number,
      payload: UpdateLeadFormSettingsPayload
    ): Promise<LeadFormSettings> {
      const { data } = await wrapApiCall(() =>
        client.put<LeadFormSettings>(`/crm/branches/${branchId}/lead-form/settings`, payload)
      )
      return data
    },

    async uploadBackground(branchId: number, file: File): Promise<UploadBackgroundResponse> {
      const form = new FormData()
      form.append('image', file)
      const { data } = await wrapApiCall(() =>
        client.post<UploadBackgroundResponse>(
          `/crm/branches/${branchId}/lead-form/background-image`,
          form,
          { headers: { 'Content-Type': 'multipart/form-data' } }
        )
      )
      return data
    },

    async deleteBackground(branchId: number): Promise<void> {
      await wrapApiCall(() => client.delete(`/crm/branches/${branchId}/lead-form/background-image`))
    },

    async uploadLogo(branchId: number, file: File): Promise<UploadLogoResponse> {
      const form = new FormData()
      form.append('image', file)
      const { data } = await wrapApiCall(() =>
        client.post<UploadLogoResponse>(`/crm/branches/${branchId}/lead-form/logo-image`, form, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
      )
      return data
    },

    async deleteLogo(branchId: number): Promise<void> {
      await wrapApiCall(() => client.delete(`/crm/branches/${branchId}/lead-form/logo-image`))
    },
  }
}

export type {
  LeadFormSettings,
  UpdateLeadFormSettingsPayload,
  UploadBackgroundResponse,
  UploadLogoResponse,
} from './model'
